import React, { PropsWithChildren } from 'react'

export const DeltaTrialTimelineContainer: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className='d-flex flex-column gap-3 mb-4'>
      <h6>How the free trial works</h6>
      <div className='d-flex gap-3'>
        <div className='delta-trial-timeline' />
        <div className='d-flex flex-column gap-3 pt-1'>{children}</div>
      </div>
    </div>
  )
}
